import image_1 from './assets/card-1.webp';
import image_2 from './assets/card-2.webp';
import image_3 from './assets/card-3.webp';
import image_4 from './assets/card-4.webp';
import image_5 from './assets/card-5.webp';

export const featureContent = {
  title: 'особенности',
  subtitle: [
    { text: 'больше, чем просто квартира: ', accent: false },
    { text: '5 особенностей «Причала»', accent: true },
  ],
  cards: [
    {
      title: [
        { text: 'курорт на пороге', accent: true },
        { text: 'вашего дома', accent: false },
      ],
      text: [
        {
          text: 'закрытая территория для&nbsp;жителей с шезлонгами и&nbsp;панорамным',
          accent: true,
        },
        { text: 'видом на Каму', accent: false },
      ],
      is_large_text: false,
      image: image_1,
    },
    {
      title: [
        { text: 'тишина как стандарт', accent: true },
        { text: 'бизнес-класса', accent: false },
      ],
      text: [
        { text: 'камерный формат на 4 этажа. атмосфера', accent: true },
        { text: 'резиденции, где все свои и нет суеты в лобби', accent: false },
      ],
      is_large_text: false,
      image: image_2,
    },
    {
      title: [
        { text: 'инженерная', accent: true },
        { text: 'независимость', accent: false },
        { text: 'и комфорт', accent: false },
      ],
      text: [
        { text: 'вы не зависите от городских графиков и сами', accent: true },
        { text: 'настраиваете комфортную температуру отопления в квартире', accent: false },
      ],
      is_large_text: false,
      image: image_3,
    },
    {
      title: [
        { text: 'биометрия вместо', accent: true },
        { text: 'связки ключей', accent: false },
      ],
      text: [
        { text: 'закрытая территория для&nbsp;жителей с шезлонгами', accent: true },
        { text: 'и&nbsp;панорамным видом на Каму', accent: false },
      ],
      is_large_text: false,
      image: image_4,
    },
    {
      title: [
        { text: 'развитие курортного', accent: true },
        { text: 'кластера', accent: false },
      ],
      text: [
        {
          text: 'городской пляж уже благоустроен. медицинский городок функционирует',
          accent: true,
        },
        {
          text: 'и&nbsp;расширяется. А в&nbsp;планах развития района —&nbsp;открытие всесезонных терм Baden-Baden',
          accent: false,
        },
      ],
      is_large_text: true,
      image: image_5,
    },
  ],
  area: {
    title: [
      { text: 'район', accent: true },
      { text: '«Верхняя Курья»', accent: true },
      { text: 'в Перми — экологический', accent: false },
      { text: 'оазис с городским', accent: false },
      { text: 'комфортом', accent: false },
    ],
    text: [
      { text: 'место, где ценность каждого', accent: true },
      { text: 'квадратного метра растет', accent: true },
      { text: 'быстрее, чем в центре города', accent: false },
    ],
  },
};
